// fetchPusherChannelData.js
'use strict';
import 'isomorphic-fetch';

import getMeData from '../selector/getMeData.js';
import getOperationData from '../selector/getOperationData.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import handleFetchError from '../resource/handleFetchError.js';
import handlePusherAuthenticated from '../action/handlePusherAuthenticated.js';
import env from '../resource/env.js';

import {
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

/**
 * Fetch pusher channel data
 * @kind action
 * @param {[strings]} {channels} - channel name list.
 * @return {Promise} Action promise.
 */

export const fetchPusherChannelData =
  ({ channels }) =>
  dispatch => {
    if (!channels.length) return dispatch({ type: '' });

    // Divide into 10 ids  per group
    for (let i = 0; i < channels.length; i += 10) {
      const groupChannels = channels.slice(i, i + 10);
      dispatch(fetchPusherChannelDataCore({ channels: groupChannels }));
    }
  };

export const fetchPusherChannelDataCore =
  ({ channels }) =>
  async (dispatch, getState) => {
    const pusherSocketId =
      getOperationData(getState(), ['pusher'], 'socketId') || null;
    if (!env.PUSHER_APP_ID || !pusherSocketId) return dispatch({ type: '' });

    const fetchOptions = {
      method: 'GET',
      headers: {
        ...getHeaders(),
        // 'Content-Type': 'application/json', // Remove this line if no payload.
      },
    };

    if (fetchOptions.headers['X-AB']) {
      delete fetchOptions.headers['X-AB'];
    }

    const token = getMeData(getState(), 'token');
    if (token) {
      fetchOptions.authorization = `Bearer ${token}`;
    }

    const fetchUrl = getResourceUrl({ endpoint: '/pusher/batch-authenticate' });

    fetchUrl.searchParams.append('app_id', env.PUSHER_APP_ID);
    fetchUrl.searchParams.append('socket_id', pusherSocketId);
    channels?.slice(0, 10)?.forEach(channel => {
      fetchUrl.searchParams.append('channels', channel);
    });

    const selectPath = ['pusher', 'batch-authenticate', channels.join(' ')];
    dispatch({ type: SET_NETWORKING_FETCHING, payload: { selectPath } });
    try {
      let response = await fetch(fetchUrl.href, fetchOptions);
      if (!response.ok) {
        response = await handleFetchError({
          response,
          dispatch,
          getState,
          fetchOptions,
          fetchUrl,
        });
      }

      const data = await response.json();
      Object.keys(data).forEach(channel => {
        dispatch(
          handlePusherAuthenticated({
            channel,
            ...data[channel],
          })
        );
      });

      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath },
      });
    } catch (error) {
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath, error },
      });
    }
  };

export default fetchPusherChannelData;
